import { withSafeSuspense } from '@calendly/safe-suspense'
import { lazy } from 'react'

export const WizardAcknowledgementModal = withSafeSuspense(
  lazy(
    async () => ({ default: (await import('./wizard_acknowledgement_modal.js')).WizardAcknowledgementModal })
  ),
  null
)
